module.exports = __webpack_public_path__ + "static/media/WhiteDesperado.e55f00c7.jpg";